<template>
  <div class="boxbgcolor">
    <div class="left">
      <div class="searchbox">
        <form action="#" method="get" class="form-inline">
          <div class="form-group">
            <input
              v-model="search.groupName"
              class="form-control"
              type="text"
              placeholder="请输入角色名称"
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="groupList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :disabled="queryLoading"
              >
                <i v-if="queryLoading" class="el-icon-loading"></i>
                {{ queryLoading ? "查询中..." : "查询" }}
              </button>
            </span>
            <span class="add_btn">
              <button type="button" class="btn btn-default" id="addScope" @click="addrOrEdit()">添加</button>
            </span>
          </div>
        </form>
      </div>
      <div class="el-tree-left">
        <div class="title">角色列表</div>
        <el-tree :data="handleGroupTree" :props="defaultProps" @node-click="handleGroupTreeClick">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" @click="() => addrOrEdit(data.id)">
                修改
                <!--<i class="el-icon-edit"></i>-->
              </el-button>
              <el-button type="text" size="mini" @click="() => delGroup(data.id)">
                删除
                <!--<i class="el-icon-delete"></i>-->
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="right">
      <div class="author">
        <!--<button  type="button" class="btn btn-primary" id="confirmAuthor" @click="confirmAuthor()">确认授权</button>-->
        <div class="title">权限列表</div>
      </div>
      <div class="right_left">
        <button
          type="button"
          class="btn btn-primary"
          id="confirmAuthor"
          @click="confirmAuthor()"
        >确认授权</button>
        <el-tree
          :data="authorTree"
          show-checkbox
          node-key="id"
          ref="tree"
          highlight-current
          default-expand-all
          :props="defaultProps"
          @node-click="authorTreeClick"
        ></el-tree>
      </div>
      <div class="right_right">
        <!--<button  type="button" class="btn btn-primary" id="confirmAuthor" @click="confirmAuthor()">按钮授权</button>-->
        <div v-if="buttonGroup">
          <el-tree
            ref="buttonTree"
            :data="handleButtonTree"
            show-checkbox
            default-expand-all
            node-key="id"
            highlight-current
            :props="defaultProps"
            @check="buttonSure"
          ></el-tree>
        </div>
        <div else></div>
      </div>
      <div></div>
    </div>

    <!--添加修改角色-->
    <el-dialog
      title="添加/修改角色"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      :lock-scroll="false"
    >
      <el-form :model="form" :rules="rulesGroup" ref="group">
        <el-form-item label="角色名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="编码" :label-width="formLabelWidth" prop="code">
          <el-input v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="description">
          <el-input v-model="form.description"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addrOrEditTrue" @keyup.enter="addrOrEditTrue">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  queryButtonList,
  getGroupCheckedList,
  getOneMenuButtons,
  addGroup,
  getGroupAuthorList,
  getGroupList,
} from "@/api/url";

export default {
  data() {
    return {
      buttonGroup: false,

      dialogFormVisible: false,
      actionScopeManager_btn_edit: false,
      actionScopeManager_btn_add: false,
      actionScopeManager_btn_delete: false,
      formLabelWidth: "100",
      buttonTree: [],
      checkedButtonList: [],
      queryLoading: false,
      search: {
        groupName: "",
      },
      groupTree: [],
      authorTree: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      //添加或修改
      form: {
        id: "",
        code: "",
        description: "",
        groupType: "org",
        name: "",
      },
      autoExpend: [],
      parentId: "",
      //点击作用域树
      groupTreeClick: {
        text: "",
      },
      menuTreeClick: {
        menuId: "",
      },
      checkedNodes: "",
      //setCheckedNod:[]
      rulesGroup: {
        name: [
          { required: true, message: "请填写角色名称", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    //角色树相关操作
    groupList() {
      if (this.queryLoading) return;
      this.queryLoading = true;
      this.$get(getGroupList(), {
        name: this.search.groupName,
        groupType: "org",
      })
        .then((data) => {
          //if(data.status!=200) return;
          this.groupTree = data;
        })
        .finally(() => {
          this.queryLoading = false;
        });
    },
    handleGroupTreeClick(node, data) {
      this.groupTreeClick.text = node.id;
      this.groupAuthorList();
      this.groupAuthorCheckedList();
      this.buttonGroup = false;
    },
    //菜单树相关操作
    groupAuthorList() {
      this.$get(getGroupAuthorList(), {}).then((data) => {
        //if(data.status!=200) return;
        this.authorTree = data;
      });
    },
    groupAuthorCheckedList() {
      this.$get(
        getGroupCheckedList() + "/" + this.groupTreeClick.text,
        {}
      ).then((data) => {
        var checkedList = [];
        var d = data.data[0];
        if (d) {
          console.log(data.data[0]);
          (function c() {
            var data = arguments[0];
            if (data.children.length == 0) {
              checkedList.push(data.id);
            } else {
              data.children.map((ele) => {
                return c(ele);
              });
            }
          })(d);
        }
        this.$refs.tree.setCheckedKeys(checkedList);
      });
    },

    getCheckedNodes() {
      var checked = this.$refs.tree.getCheckedNodes();
      console.log("checked");
      console.log(checked);
      var content = "";
      for (let item of checked) {
        content += item.id + ",";
      }
      this.checkedNodes = content;
    },
    confirmAuthor() {
      this.getCheckedNodes("tree");
      this.$postRequest(
        addGroup() +
          "/" +
          this.groupTreeClick.text +
          "/authority/menu?menuTrees=" +
          this.checkedNodes.substr(0, this.checkedNodes.length - 1),
        {}
      ).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          title: "成功",
          message: "授权成功!",
          type: "success",
        });
        this.groupAuthorCheckedList();
      });
    },

    authorTreeClick(node, data) {
      console.log(data);
      // if (data.level == 3) {
      this.buttonGroup = true;
      this.menuTreeClick.menuId = node.id;
      this.getButtonList();
      this.getCheckedButtonList();
      // } else {
      //   this.buttonGroup = false;
      // }
    },
    //按钮树相关操作
    getButtonList() {
      this.$get(queryButtonList(), {
        menuId: this.menuTreeClick.menuId,
      }).then((data) => {
        if (data.status != 200) return;
        this.buttonTree = data.data.rows;
      });
    },
    getCheckedButtonList() {
      var _this = this;
      this.$get(
        addGroup() +
          "/authority/element/" +
          this.groupTreeClick.text +
          "?menuId=" +
          this.menuTreeClick.menuId,
        {}
      ).then((data) => {
        if (data.status != 200) return;
        _this.$refs.buttonTree.setCheckedKeys(data.data);
      });
    },
    buttonSure(node, data) {
      var _this = this;
      let flag = false;
      for (let item of data.checkedKeys) {
        if (node.id == item) {
          flag = true;
          break;
        }
      }
      if (flag) {
        this.$postRequest(
          addGroup() +
            "/" +
            this.groupTreeClick.text +
            "/authority/element/add?menuId=" +
            this.menuTreeClick.menuId +
            "&elementId=" +
            node.id
        ).then((data) => {
          if (data.status != 200) return;
          _this.$notify({
            title: "成功",
            message: "添加权限成功",
            type: "success",
          });
        });
      } else {
        this.$postRequest(
          addGroup() +
            "/" +
            this.groupTreeClick.text +
            "/authority/element/remove?menuId=" +
            this.menuTreeClick.menuId +
            "&elementId=" +
            node.id
        ).then((data) => {
          if (data.status != 200) return;
          _this.$notify({
            title: "成功",
            message: "移除权限成功",
            type: "success",
          });
        });
      }
    },

    searchList() {},
    //角色增删改
    addrOrEdit(id, node, data) {
      var _this = this;
      this.dialogFormVisible = true;
      if (id !== undefined && id != "") {
        //this.form.id=id;
        _this
          .$get(addGroup() + "/" + id, {
            id: id,
          })
          .then((data) => {
            if (data.status != 200) {
              return;
            }

            _this.form.id = data.data.id;
            _this.form.code = data.data.code;
            _this.form.description = data.data.description;
            _this.form.groupType = data.data.groupType;
            _this.form.name = data.data.name;
            //this.groupTreeClick.parentId=data.data.parentId
          });
      } else {
        _this.form = {
          id: "",
          code: "",
          description: "",
          groupType: "org",
          name: "",
        };
      }
    },
    addrOrEditTrue() {
      var _this = this;
      this.$refs["group"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (_this.form.id == "") {
            _this
              .$postRequest(addGroup(), {
                code: _this.form.code,
                description: _this.form.description,
                groupType: _this.form.groupType,
                name: _this.form.name,
                parentId: "-1",
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.$notify({
                    type: "warning",
                    title: "失败",
                    message: data.message,
                  });
                  return;
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功！",
                });
                _this.groupList();
              });
          } else {
            _this
              .$putRequest(addGroup() + "/" + _this.form.id, {
                id: _this.form.id,
                code: _this.form.code,
                description: _this.form.description,
                groupType: _this.form.groupType,
                name: _this.form.name,
                parentId: "-1",
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.$notify({
                    type: "warning",
                    title: "失败",
                    message: data.message,
                  });
                  return;
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功！",
                });
                _this.groupList();
              });
          }
        }
      });
    },
    delGroup: function (id) {
      var _this = this;
      console.log(id);
      var index = _this.$layer.confirm(
        "您确定删除该角色吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this
            .$deleteRequest(addGroup() + "/" + id, {
              id: id,
              //enabledFlag:'n'
            })
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功！",
              });
              _this.groupList();
              _this.authorTree = [];
            });
        }
      );
    },
  },

  computed: {
    ...mapGetters(["elements"]),
    permiss() {
      // this.actionScopeManager_btn_edit = this.elements['actionScopeManager:btn_edit'];
      // this.actionScopeManager_btn_add = this.elements['actionScopeManager:btn_add'];
      // this.actionScopeManager_btn_delete = this.elements['actionScopeManager:btn_delete'];
    },
    handleGroupTree() {
      //console.log(this.scopeNameTree.rows)
      var resultGroupTree = [];
      if (this.groupTree != null && this.groupTree != undefined) {
        for (let item of this.groupTree) {
          let ite = {};
          ite.label = item.name;
          ite.id = item.id;
          //console.log("ite.id")
          //console.log(ite.id)
          resultGroupTree.push(ite);
        }
      }

      return resultGroupTree;
    },

    handleButtonTree() {
      var resultButtonTree = [];
      if (this.buttonTree != null && this.buttonTree != undefined) {
        //console.log(66666)
        for (let item of this.buttonTree) {
          let ite = {};
          ite.label = item.name;
          ite.id = item.id;
          // ite.ischeck=item.ischeck;
          //console.log("ite.id")
          //console.log(ite.id)
          resultButtonTree.push(ite);
        }
      }
      return resultButtonTree;
    },
  },
  components: {},
  created: function () {},
  mounted: function () {
    this.permiss;
    this.groupList();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.el-checkbox-group {
  display: inline-block;
}
.right_left {
  width: 40%;
  float: left;
  margin-left: 20px;
  border-right: 1px solid #ccc;
}
.right_left .el-tree {
  padding-top: 10px;
}
.right_right {
  float: right;
  width: 50%;
  padding-right: 20%;
}
.right_right > div {
  padding-top: 10px;
}
.author {
  margin-bottom: 20px;
}
.left {
  float: left;
  width: 40%;
  border-right: 10px solid #eff2f7;
  height: calc(100vh - 125px);
}
.left .el-tree {
  height: calc(100vh - 255px);
  overflow: auto;
  padding-bottom: 20px;
}
.right {
  float: right;
  width: 60%;
  height: calc(100vh - 125px);
}

.right .el-tree {
  height: calc(100vh - 235px);
  overflow: auto;
  padding-bottom: 20px;
}
.author {
  padding: 0;
  /*padding-top: 10px;*/
  background: #f9f9fb;
  width: 100%;
  /*border-bottom: 10px solid #eff2f7;*/
  height: 55px;
  line-height: 55px;
  padding-left: 10px;
  border-bottom: 1px solid #dddddd;
}
.author button {
  margin-left: 10px;
}
.author .title {
  text-align: center;
  height: 55px;
  width: 84%;
  float: right;
  color: #278cd8;
  font-weight: bold;
}
.el-tree-left .title {
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
  background: #f9f9fb;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #278cd8;
}
</style>
